import {CLOSE_CLASS_NAME, CREATE_TAG_CLASS_NAME, GROUP_CLASS_NAME, TAG_LIST_CLASS_NAME} from "../constants";
import {renderElement} from "../../utils/common";
import {getCreateTagModal, getTagTemplate} from "../template";
import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";

/**
 * Функционал создания метки. В конструктор передаётся родитель "группа меток" в которую будет создаваться новая метка.
 */
class CreateTag {
  #parent;
  #tagList;
  #modalElement;
  #formElement;
  #groupId;
  #radioElements;
  #nameElement;

  #api = new Api();

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);

    document.addEventListener(`click`, this.onDocumentClick);
  }

  /**
   * Инициация и генерация модалки создания метки
   */
  #init() {
    this.#groupId = +this.#parent.dataset.id;
    this.#tagList = this.#parent.querySelector(`.${TAG_LIST_CLASS_NAME}`);

    this.formSubmitHandler = this.formSubmitHandler.bind(this);
    this.modalClickHandler = this.modalClickHandler.bind(this);

    this.#renderModal();
  }

  /**
   *  Генерация окна создания метки и активация слушателя на форме
   */
  #renderModal() {
    this.#modalElement = renderElement(document.body, getCreateTagModal(this.#groupId));

    if (this.#modalElement) {
      this.#formElement = this.#modalElement.querySelector(`form`);
      this.#nameElement = this.#formElement.querySelector(`input[type=text]`);
      this.#radioElements = Array.from(this.#formElement.querySelectorAll(`input[type=radio]`));

      this.#formElement.addEventListener(`submit`, this.formSubmitHandler);
      this.#modalElement.addEventListener(`click`, this.modalClickHandler);
    }
  }

  /**
   *  Валидно ли поле с названием метки
   * @returns {boolean}
   */
  #isNameValid() {
    return this.#nameElement.value.trim().length !== 0;
  }

  /**
   *  Активирован ли чекбокс с цветом метки
   * @returns {boolean}
   */
  #isColorChecked() {
    return this.#radioElements.some((radio) => radio.checked);
  }

  /**
   *  Получение данных формы
   */
  #getTagData() {
    return {
      id: this.#groupId,
      name: this.#nameElement.value.trim(),
      color: this.#radioElements.find((radio) => radio.checked).value,
    };
  }

  /**
   *  Отправка запроса и создание метки, в случае успешной передачи данных.
   */
  async #postData() {
    const {code, answer} = await this.#api.customQuery(this.#formElement.action, {method: Method.POST, query: JSON.stringify(this.#getTagData())}); // TODO: Поменять на POST

    const tagName = this.#nameElement.value.trim();
    const tagColor = this.#radioElements.find((radio) => radio.checked).value;

    if (code === 200) {
      this.#createTag(answer.data.id, tagName, tagColor);
      this.#removeModal();
    } else {
      showToast(answer.text);
    }
  }

  /**
   * Создание метки, генерация элемента метки в общем листинге меток.
   *
   * @param id {number} - идентификатор метки
   * @param tagName {string} - имя метки
   * @param tagColor {string} - цвет метки в формате hex
   */
  #createTag(id, tagName, tagColor) {
    renderElement(this.#tagList, getTagTemplate(tagColor, tagName, id));
  }

  #removeModal() {
    this.#modalElement.remove();
  }

  /**
   *  Слушатель отправки формы и в случае её валидности, отправка данных
   */
  formSubmitHandler(event) {
    event.preventDefault();

    if (this.#isNameValid() && this.#isColorChecked()) {
      void this.#postData();
    } else {
      this.#formElement.classList.add(`form--error`);
    }
  }

  /**
   *  Слушатель клика на модальном окна создания метки
   */
  modalClickHandler(event) {
    const target = event.target;
    if (target.classList.contains(CLOSE_CLASS_NAME)) {
      this.#removeModal();
    }
  }

  onDocumentClick({target}) {
    if (target.classList.contains(CREATE_TAG_CLASS_NAME)) {
      this.#parent = target.closest(`.${GROUP_CLASS_NAME}`);

      this.#init();
    }
  }
}

export {CreateTag};
